// IO Frontend/src/config.js
const config = {
  API_URL: 'https://social-locker-backend.onrender.com',
};

export default config;